import { Card, Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/elements/Button';
import ButtonLink from '../../components/elements/ButtonLink';
import SelectBox from '../../components/fields/SelectBox';
import Text from '../../components/fields/Text';
import { toUpperCase } from '../../utils/format';
import { addCategoryToList, fetchCategoryV2, fetchFaqV2ById } from './actions';
import FormCategory from './FormCategory';
import styles from './styles.scoped.css';

import { Editor } from '@tinymce/tinymce-react';
import TextArea from '../../components/fields/TextArea';
import { uploadImageFaq } from '../../utils/api';
import { TINYAPI } from '../../../env';

export function Component({
  change,
  handleSubmit,
  submitting,
  // item = {},
  // onCloseModal = () => {},
  type = null,
  initialize,
}) {
  const dispatch = useDispatch();

  const [category, setCategory] = useState('');
  const [answer, setAnswer] = useState('');
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [errorUpload, setErrorUpload] = useState('');
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [prevFaqId, setPrevFaqId] = useState('');

  const { faqId = '' } = queryString.parse(location.search.replace('?', ''));

  const { dataFaqById, isLoadingFaqById, dataCategoriesV2 } = useSelector(
    (s) => s.faq
  );

  const question = {
    placeholder: 'Tuliskan judul pertanyaan',
  };

  const description = {
    placeholder: 'Tulis jawaban dari pertanyaan diatas',
    label: 'Deskripsi',
  };

  const onChangeCategory = (e) => {
    if (e === 'tambah') {
      setOpenCategoryModal(true);
    } else {
      setCategory(e);
      setAfterSubmit(false);
      change('category', e);
    }
  };

  useEffect(() => {
    dispatch(fetchCategoryV2());
    if (type === 'edit') {
      dispatch(fetchFaqV2ById(faqId));
      setPrevFaqId(faqId);
    } else {
      resetForm();
    }
  }, []);

  useEffect(() => {
    if (type === 'edit' && faqId !== prevFaqId) {
      resetForm();
      dispatch(fetchFaqV2ById(faqId));
      setPrevFaqId(faqId);
    }
  }, [faqId]);

  const resetForm = () => {
    setCategory('');
    setAnswer('');
    initialize({
      category: '',
      answer: '',
      question: '',
    });
  };

  const _handleEditorChange = (editorState) => {
    setAnswer(editorState);
    change('answer', editorState.target.getContent());
  };

  const fileToBase64 = (val) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const uploadImageCallBack = async (blobInfo, success) => {
    const file = blobInfo.blob();
    setErrorUpload('');
    if (file.size <= 2000000) {
      try {
        const base64 = await fileToBase64(file);
        const params = {
          image: base64,
        };
        const data = await uploadImageFaq(params);
        return success(data?.data?.link);
      } catch (error) {
        return error;
      }
    } else {
      setErrorUpload('Maksimal Ukuran file 2 MB');
    }
  };

  useEffect(() => {
    if (afterSubmit) {
      setOpenCategoryModal(false);
    }
  }, [afterSubmit]);

  useEffect(() => {
    if (!isLoadingFaqById && type === 'edit' && dataFaqById) {
      setCategory(dataFaqById?.category || '');
      change('category', dataFaqById?.category || '');
      change('answer', dataFaqById?.answer || '');
      change('question', dataFaqById?.question || '');
      setAnswer(dataFaqById?.answer || '');
    }
  }, [isLoadingFaqById, dataFaqById]);

  const setCategoryAfterAdd = (values) => {
    setCategory(toUpperCase(values.addCategory));
    change('category', toUpperCase(values.addCategory));
  };

  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        <h4>
          {type === 'edit' ? 'Edit FAQ Subpangkalan' : 'Buat FAQ Subpangkalan'}
        </h4>
        <form onSubmit={handleSubmit}>
          <div className={styles['input-group']}>
            <label>Kategori</label>
            <Field
              component={SelectBox}
              data={[
                {
                  group: ' ',
                  items: [{ value: 'tambah', label: 'Tambah Kategori' }],
                },
                {
                  group: ' ',
                  items: [
                    {
                      value: '',
                      label: 'Pilih Kategori',
                    },
                    ...dataCategoriesV2,
                  ],
                },
              ]}
              defaultValue={category}
              name="category"
              onChangeSelect={(e) => onChangeCategory(e)}
              searchable={false}
              valueForm={category}
            />
          </div>
          <div className={styles['input-group']}>
            <label>Judul Pertanyaan</label>
            <Field component={Text} inputProps={question} name="question" />
          </div>
          <div className={styles['input-group']}>
            <label>Deskripsi</label>
            <Editor
              apiKey={TINYAPI}
              init={{
                height: 600,
                menubar: true,
                config: {},
                images_upload_credentials: true,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar: `link code image | formatselect | bold italic backcolor | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help`,
                image_title: true,
                automatic_uploads: true,
                file_picker_types: 'image',
                images_upload_handler: uploadImageCallBack,
              }}
              initialValue={answer}
              key={`editor-${faqId || 'new'}`}
              onChange={_handleEditorChange}
            >
              <Field
                component={TextArea}
                inputProps={description}
                name="answer"
              />
            </Editor>
            <span style={{ color: '#EA2036' }}>{errorUpload}</span>
          </div>
          <div className={styles['form-action']}>
            <>
              <ButtonLink
                className={styles['action-btn-back']}
                outlined={true}
                to={'/faq?tab=subpangkalan'}
              >
                Kembali
              </ButtonLink>
              <Button
                disabled={submitting || isLoadingFaqById}
                type="submit"
              >
                Simpan
              </Button>
            </>
          </div>
        </form>
      </Card>
      {type !== 'detail' && (
        <Modal centered opened={openCategoryModal} withCloseButton={false}>
          <FormCategory
            onBack={() => setOpenCategoryModal(false)}
            onSubmit={(values) =>
              dispatch(
                addCategoryToList(
                  values,
                  () => {
                    setOpenCategoryModal(false);
                    setCategoryAfterAdd(values);
                  },
                  true
                )
              )
            }
          />
        </Modal>
      )}
    </div>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  item: PropTypes.object,
  onCloseModal: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  type: PropTypes.string,
};

export default reduxForm({
  form: 'faqSubpangkalan',
  initialValues: {
    question: '',
    answer: '',
    category: '',
  },
  validate: (values) => {
    const errors = {};
    if (!values.question) {
      errors.question = { _error: 'Pertanyaan harus diisi' };
    }
    if (!values.answer) {
      errors.answer = { _error: 'Deskripsi harus diisi' };
    }
    if (!values.category) {
      errors.category = { _error: 'Kategori harus diisi' };
    }
    return errors;
  },
  enableReinitialize: true,
})(Component);
